import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

export interface QuestionDto {
  id: number;
  organizationId: number;
  gameFlowId?: number;
  dateCreated: string;
  questionText: string;
  isEnabled?: boolean;
  isDeleted?: boolean;
}

export interface GameFlowModeDto {
  id: number;
  name: string;
  description?: string;
  defaultMode: boolean;
  supportsHints?: boolean;
}

export interface QuestionCreateDto {
  organizationId: number;
  questionText: string;
  gameFlowId?: number;
}

export interface QuestionUpdateDto {
  questionText: string;
  gameFlowId: number;
}

@Injectable({
  providedIn: 'root'
})
export class QuestionService {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = '/api/questions';

  getAll(): Observable<QuestionDto[]> {
    return this.http.get<QuestionDto[]>(this.apiUrl);
  }

  getAllForUtilities(): Observable<QuestionDto[]> {
    return this.http.get<QuestionDto[]>(`${this.apiUrl}/utilities`);
  }

  getActiveGameFlowModes(): Observable<GameFlowModeDto[]> {
    return this.http.get<GameFlowModeDto[]>('/api/GameFlowModes');
  }

  create(data: QuestionCreateDto): Observable<QuestionDto> {
    return this.http.post<QuestionDto>(this.apiUrl, data);
  }

  update(id: number, data: QuestionUpdateDto): Observable<QuestionDto> {
    return this.http.put<QuestionDto>(`${this.apiUrl}/${id}`, data);
  }

  delete(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`);
  }

  setEnabled(id: number, isEnabled: boolean): Observable<QuestionDto> {
    return this.http.put<QuestionDto>(`${this.apiUrl}/${id}/enabled`, { isEnabled });
  }

  restore(id: number): Observable<QuestionDto> {
    return this.http.put<QuestionDto>(`${this.apiUrl}/${id}/restore`, {});
  }

  hardDelete(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}/hard`);
  }
}